import {
  ActivityAutofillBanner,
  DuplicateRowsErrorBanner,
  ExistingAssignmentsBanner,
  NetworkErrorBanner,
  RespondentAutofillBanner,
  SubjectAutofillBanner,
} from './Banners';

export const ActivityAssignBannerComponents = {
  ActivityAutofillBanner,
  DuplicateRowsErrorBanner,
  ExistingAssignmentsBanner,
  NetworkErrorBanner,
  RespondentAutofillBanner,
  SubjectAutofillBanner,
};
